import { AppBar, Toolbar, Box } from "@mui/material";
import LogoImg from "../../../assets/images/logo.png";
import Navbar from "@components/molecules/Navbar/Navbar";
import Offset from "@components/atoms/Offset/Offset";
const MyAppBar = () => {
  return <>
      <AppBar position="fixed" elevation={10} sx={{
      backgroundColor: "primary.light"
    }}>
        <Toolbar sx={{
        backgroundColor: "white",
        paddingY: 1
      }}>
          <Box component={"img"} src={LogoImg} width={120} />
        </Toolbar>
        <Navbar />
      </AppBar>
      <Offset />
      <Offset />
    </>;
};
export default MyAppBar;